import { Fragment } from 'react';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitleApproversList(props) {
  const {
    approval
  } = props;
  return /*#__PURE__*/_jsx("span", {
    className: "m-left-1",
    children: approval.data.approvalSteps.map((approvalStep, index) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ApprovalUserFormattedName, {
        approvalUser: approvalStep.approver
      }), index < approval.data.approvalSteps.length - 1 && ', ']
    }, approvalStep.id))
  });
}
export default PendingApprovalButtonI18nTitleApproversList;